import React, { createContext, useContext, useState } from 'react';
export function getGlobalStateUtils(initialGlobalState) {
  var initialState = initialGlobalState || {};
  var GlobalStateContext = /*#__PURE__*/createContext({
    state: initialState,
    setState: () => null
  }); // needs to be at the top level component to provide the global state for all child/grandchild/... components

  function GlobalStateProvider(props) {
    var {
      children
    } = props;
    var [globalState, setGlobalState] = useState(initialState);
    return /*#__PURE__*/React.createElement(GlobalStateContext.Provider, {
      value: [globalState, setGlobalState]
    }, children);
  }

  ;

  function useStateSlice(sliceName) {
    var [globalState, setGlobalState] = useContext(GlobalStateContext);

    function setStateSlice(newValues) {
      setGlobalState(currentGS => {
        if (typeof newValues === 'function') {
          newValues = newValues(currentGS[sliceName]);
        }

        if (newValues == null) {
          // needs to be an object for the slice, so this means we want to skip the update
          return currentGS;
        }

        return { ...currentGS,
          [sliceName]: { ...currentGS[sliceName],
            ...newValues
          }
        };
      });
    }

    return [globalState[sliceName], setStateSlice];
  }

  ;
  return {
    GlobalStateProvider,
    useStateSlice
  };
}